import React, {Component} from 'react';
import {Link} from 'react-router';
import classnames from 'classnames';
import PropTypes from 'prop-types';

export default class Paginator extends Component {

    static propTypes = {
        totalPages: PropTypes.number,
        currentPage: PropTypes.number,
        paginationAction: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            pageRangeDisplayed: 5,
            marginPagesDisplayed: 5
        };
    }

    getPaginationItems() {
        let items = [];
        let selected = this.props.currentPage;
        let pageCount = this.props.totalPages;
        let pageRangeDisplayed = this.state.pageRangeDisplayed;

        if (pageCount <= pageRangeDisplayed) {
            for (var i = 0; i < pageCount; i++) {
                const page = i + 1;
                items['key' + i] = page;
            }

        } else {
            let leftSide = (pageRangeDisplayed / 2),
                rightSide = (pageRangeDisplayed - leftSide);

            if (selected > pageCount - pageRangeDisplayed / 2) {
                rightSide = pageCount - selected;
                leftSide = pageRangeDisplayed - rightSide;
            } else if (selected < pageRangeDisplayed / 2) {
                leftSide = selected;
                rightSide = pageRangeDisplayed - leftSide;
            }

            let index,
                page,
                breakView;

            for (index = 0; index < pageCount; index++) {
                page = index + 1;
                let pageView = page;

                if (page <= this.state.marginPagesDisplayed) {
                    items['key' + index] = pageView;
                    continue;
                }

                if (page > pageCount - this.state.marginPagesDisplayed) {
                    items['key' + index] = pageView;
                    continue;
                }
                if ((index >= selected - leftSide) && (index <= selected + rightSide)) {
                    items['key' + index] = pageView;
                    continue;
                }

                let keys = Object.keys(items),
                    breakLabelKey = keys[keys.length - 1],
                    breakLabelValue = items[breakLabelKey];

                if (breakLabelValue !== breakView) {
                    breakView = 'BREAK';
                    items['key' + index] = breakView;
                }
            }
        }

        return items;
    }

    getUrlForPage(page) {
        const {baseUrl} = this.props;
        if (page) {
            return `${baseUrl}/page/${page}`;
        }
        return baseUrl;
    }

    render() {
        const {currentPage, paginationAction} = this.props;
        const items = this.getPaginationItems();
        return (
            <div>
                <ul className="paginator">
                    {Object.keys(items).map((key) => {
                        const page = items[key];
                        if (page === 'BREAK') {
                            return (
                                <li key={`page-${page}-${key}`}>
                                    <a>...</a>
                                </li>
                            );
                        }
                        return (
                            <li key={`page-${page}`} className={classnames({
                                'active': page - 1 === currentPage
                            })}>
                                {paginationAction
                                    ? <a onClick={() => {
                                        paginationAction({
                                            page: page - 1
                                        });
                                    }}>
                                        {page}
                                    </a>
                                    : <Link to={this.getUrlForPage(page - 1)}>
                                        {page}
                                    </Link>}
                            </li>
                        );

                    })}
                </ul>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/components/data-table/paginator.jsx